import { render, staticRenderFns } from "./CourseEventSave.vue?vue&type=template&id=3ac40aaa&scoped=true"
import script from "./CourseEventSave.vue?vue&type=script&lang=ts"
export * from "./CourseEventSave.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac40aaa",
  null
  
)

export default component.exports